import * as React from "react";

/**
 * One timestamped transcript line in the player. The current line sits on the lavender pill with a semibold label; past lines dim. Timestamps are purple and tabular.
 */
export interface TranscriptLineProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  time: string;
  text: React.ReactNode;
  state?: "past" | "current" | "future";
}

export function TranscriptLine({ time, text, state = "future", className, ...rest }: TranscriptLineProps): JSX.Element {
  return (
    <button
      type="button"
      aria-current={state === "current" ? "true" : undefined}
      className={["gk-tline", state !== "future" && "gk-tline--" + state, className].filter(Boolean).join(" ")}
      {...rest}
    >
      <span className="gk-tline__t">{time}</span>
      <span className="gk-tline__text">{text}</span>
    </button>
  );
}
